<template>
  <div class="chronic-disease-view">
    <el-card class="chronic-card chronic-card--toolbar" shadow="hover">
      <div class="chronic-toolbar">
        <el-row :gutter="16" type="flex" align="middle">
          <el-col :xs="24" :sm="16" :md="18">
            <el-date-picker
              v-model="selForm.date_span"
              class="chronic-toolbar__ctrl chronic-toolbar__daterange"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd hh:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            />
          </el-col>
          <el-col :xs="24" :sm="8" :md="6">
            <el-button type="primary" class="chronic-toolbar__btn" @click="query">查询</el-button>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-row>
      <el-col :span="24">
        <el-card class="chronic-card chronic-card--pie" shadow="hover">
          <div slot="header" class="chronic-card-header clearfix">
            <i class="el-icon-card-header"></i>
            <span>慢性病总体统计</span>
          </div>
          <div class="chronic-pie-inner">
            <PieChart
              :key="'pie-' + chartRefreshKey"
              id="chronic_disease_stat_pie"
              height="440px"
              width="100%"
              path="chronic_disease_stat_pie"
              :params="chartExtraParams"
            />
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="chronic-row chronic-row--bars">
      <el-col :span="24">
        <el-card class="chronic-card" shadow="hover">
          <div slot="header" class="chronic-card-header clearfix">
            <i class="el-icon-card-header"></i>
            <span>慢性病在各省区分布</span>
          </div>
          <el-row :gutter="20">
            <el-col
              v-for="(item, idx) in chronic_diseases"
              :key="(item.name || '') + '-' + idx + '-' + chartRefreshKey"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
            >
              <div class="chronic-bar-slot">
                <LineChart
                  :id="'chronic_bar_' + idx"
                  path="chronic_disease_stat_line"
                  height="420px"
                  width="100%"
                  :params="lineChartParams(item)"
                  expand-bottom-axis
                />
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from "moment-timezone";
import PieChart from "@/views/charts/pie";
import LineChart from "@/views/charts/line";

export default {
  name: "ChronicDiseaseView",
  components: {
    PieChart,
    LineChart,
  },
  data() {
    return {
      chronic_diseases: [],
      chartRefreshKey: 0,
      selForm: {
        date_span: [
          moment().subtract(365, "d").startOf("day").format("YYYY-MM-DD"),
          moment().endOf("day").format("YYYY-MM-DD"),
        ],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    chartExtraParams() {
      const span = this.selForm.date_span || [];
      return {
        date_start: span[0] || "",
        date_end: span[1] || "",
      };
    },
  },
  mounted() {
    this.get_chronic_diseases();
  },
  methods: {
    lineChartParams(item) {
      return {
        disease: item.name,
        ...this.chartExtraParams,
      };
    },
    query() {
      this.chartRefreshKey += 1;
      this.get_chronic_diseases();
    },
    get_chronic_diseases() {
      const p = {
        ...this.chartExtraParams,
      };
      this.$http
        .get(process.env.VUE_APP_API_HOST + "/chronic_disease_stat_pie", { params: p })
        .then((res) => {
          const raw = res.data && res.data.data;
          this.chronic_diseases = Array.isArray(raw) ? raw : [];
        });
    },
  },
};
</script>

<style scoped>
.chronic-disease-view {
  box-sizing: border-box;
  min-height: 100%;
  padding: 18px 20px 42px;
  background: radial-gradient(circle at top, #3a3f4c 0%, #262a34 45%, #1c1f27 100%);
}

.chronic-toolbar {
  display: flex;
  align-items: center;
}

.chronic-toolbar__ctrl {
  width: 100%;
}

.chronic-toolbar__daterange {
  width: 100%;
}

.chronic-toolbar__btn {
  width: 100%;
  border-radius: 6px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

@media (min-width: 992px) {
  .chronic-toolbar__btn {
    width: auto;
    min-width: 110px;
  }
}

.chronic-toolbar /deep/ .el-input__inner,
.chronic-toolbar /deep/ .el-range-input {
  background: rgba(15, 18, 25, 0.6);
  border-color: rgba(113, 176, 255, 0.28);
  color: rgba(255, 255, 255, 0.9);
}

.chronic-toolbar /deep/ .el-input__inner:focus,
.chronic-toolbar /deep/ .el-range-editor.is-active,
.chronic-toolbar /deep/ .el-range-editor.is-active:hover {
  border-color: rgba(113, 176, 255, 0.65);
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.16);
}

.chronic-toolbar /deep/ .el-range-separator {
  color: rgba(255, 255, 255, 0.5);
}

.chronic-card {
  margin-bottom: 20px;
  border-radius: 14px;
  border: 1px solid rgba(127, 176, 255, 0.14);
  background: linear-gradient(180deg, rgba(27, 31, 40, 0.95) 0%, rgba(21, 24, 32, 0.95) 100%);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.26);
  overflow: visible;
}

.chronic-card--toolbar /deep/ .el-card__body {
  padding: 18px 22px;
}

.chronic-card /deep/ .el-card__header {
  padding: 16px 22px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  background: transparent;
  color: rgba(255, 255, 255, 0.9);
}

.chronic-card /deep/ .el-card__body {
  padding: 20px 22px 28px;
}

.chronic-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: rgba(236, 245, 255, 0.96);
}

.chronic-card-header i {
  font-size: 14px;
  color: rgba(140, 196, 255, 0.95);
}

.chronic-pie-inner {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 2px 0 0;
}

.chronic-bar-slot {
  min-height: 428px;
  margin-bottom: 14px;
  border-radius: 10px;
  padding: 6px 8px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.chronic-row--bars {
  margin-bottom: 10px;
}

@media (max-width: 991px) {
  .chronic-disease-view {
    padding: 14px 14px 30px;
  }

  .chronic-card--toolbar /deep/ .el-card__body {
    padding: 14px;
  }

  .chronic-card /deep/ .el-card__header {
    padding: 12px 14px;
  }

  .chronic-card /deep/ .el-card__body {
    padding: 14px 14px 18px;
  }

  .chronic-pie-inner {
    max-width: 100%;
    padding: 0;
  }

  .chronic-bar-slot {
    min-height: 380px;
    padding: 2px;
    margin-bottom: 10px;
  }
}
</style>
